module.exports = __webpack_public_path__ + "img/1523924996.4503dfe0.jpg";